<template>
    <div v-if="firstRendered">
        <div class="filter-condition box-shadow-small border-radius">
            <div class="search-box">
                <el-button class="search-hd" type="primary" icon="el-icon-search" @click="searchKeyword(keyword)"></el-button>
                <div class="search-bd">
                    <search-bar :ajaxSearch="false" v-model="keyword" @enter-key="searchKeyword" @select="searchKeyword"
                                placeholder="请输入邮件名称"></search-bar>
                </div>
            </div>
            <filter-panel @params-change="getParams" ref="condition">
                <filter-panel-item v-for="(item, index) in filterConf" :label="item.label" :mode="item.mode"
                                   :name="item.name" :data="item.data" :key="index"
                                   :initValue="item.value"></filter-panel-item>
            </filter-panel>
        </div>
        <div class="filter-result background-white box-shadow-small border-radius">
            <div class="filter-result-header mt-15 clearfix">
                <el-row type="flex" justify="space-between">
                    <el-col :span="12">
                    </el-col>
                    <el-col :span="12">
                        <el-row v-if="lists.length" type="flex" justify="end">
                            <el-button @click="reSendEmail(idStr)" icon="el-icon-my-youjian color-primary" type="primary"
                                       :plain="true">重新发送
                            </el-button>
                            <el-button :plain="true" @click="fetchData()">刷新列表
                            </el-button>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div v-loading="partialLoading">
                <empty-tip :show="!lists.length"></empty-tip>
                <div class="table-list mt-20">
                    <el-table v-if="lists.length"
                              :data="lists"
                              @selection-change="handleSelectionChange">
                        <el-table-column
                                type="selection"
                                align="center"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="邮件名称"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="150">
                            <template slot-scope="scope">
                                <a href="javascript://" @click="$refs.preview.show(scope.row)">{{ scope.row.name
                                    }}</a>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="接收邮箱"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="120">
                            <template slot-scope="scope">
                                {{scope.row.sendEmail || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label='用户类型'
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{getSelectMapText('WB_USER_ATTRIBUTES', scope.row.userAttributes)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作人"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{scope.row.operatorUser && scope.row.operatorUser.name || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="发送状态"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{getSelectMapText('WB_SMS_SEND', scope.row.status) || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                align="center"
                                class-name="no-wrap"
                                min-width="80">
                            <template slot-scope="scope">
                                <el-button type="text" @click="reSendEmail(scope.row.id)">重新发送</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                        v-if="lists.length"
                        class="text-center mt-20 mb-20"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="pagination.pageIndex"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.recordCounts">
                </el-pagination>
            </div>
        </div>
        <view-email-history ref="preview"></view-email-history>
    </div>
</template>
<script type="text/javascript">
    import QueryListExtend from 'components/queryListExtend'
    import selectMapMixin from 'mixins/selectMapMixin'
    import operationMixin from '../operation/operationMixin'
    import ViewEmailHistory from './viewEmailHistoryItem'

    export default {
        'extends': QueryListExtend,
        'mixins': [selectMapMixin, operationMixin],
        data () {
            return {
                fetchUrl: '/system/mailHistory/list.api',
                filterConf: [{
                    name: 'status',
                    filter: 'WB_SMS_SEND',
                    label: '发送状态',
                    visible: false,
                    mode: 'single',
                    data: []
                }, {
                    name: 'userAttributes',
                    filter: 'WB_USER_ATTRIBUTES',
                    label: '用户类型',
                    mode: 'single',
                    visible: false,
                    data: []
                }],
                searchData: {
                    searchWord: null
                }
            }
        },
        methods: {
            reSendEmail (ids) {
                if (!this.checkDataValid(ids)) {
                    return false
                }
                this.$axios.post('/system/mailHistory/repeat.api', {
                    ids: ids
                }, {'X-showMessage': true}).then((res) => {
                    this.fetchData && this.fetchData()
                }).catch(() => {})
            }
        },
        components: {
            ViewEmailHistory
        }
    }
</script>
<style type="text/css" lang="scss">

</style>


// WEBPACK FOOTER //
// emailHistoryList.vue?f6becdcc